import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal, Button, Form } from "react-bootstrap";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Row, Col, Card } from "react-bootstrap";
import { Pie } from "react-chartjs-2";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const Bank = () => {
  const BaseUrl = process.env.REACT_APP_API;
  const ExchangeApiUrl = "https://api.exchangerate-api.com/v4/latest/USD";

  const [bankAccounts, setBankAccounts] = useState([]);
  const [exchangeRates, setExchangeRates] = useState({});
   const [blueAsterCapitalFund, setBlueAsterCapitalFund] = useState([]);
  const [blueAsterCapitalBSC, setBlueAsterCapitalBSC] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [updatedBalance, setUpdatedBalance] = useState("");
  const [updateDate, setUpdateDate] = useState("");
  const [updateHistory, setUpdateHistory] = useState([]);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);


  console.log("udated History",updateHistory);


  // Fetch bank account data
  useEffect(() => {
    fetchAccounts();
  }, []);

  // Fetch bank accounts
  const fetchAccounts = async () => {
    try {
      const response = await axios.get(`${BaseUrl}/accounts`);
      setBankAccounts(response.data);
      setBlueAsterCapitalFund(response.data.filter(account => account.account_name === "Blue Aster Capital Fund PCC" || account.account_name === "BLUE ASTER CAPITAL FUND P.C.C" || account.account_name === "BLUE ASTER CAPITAL FUND PCC - FOREIGN CURRENCY" || account.account_name === "BLUE ASTER CAPITAL FUND PCC - MULTI ASSET FUND" || account.account_name === "Digital Asset" ));
      setBlueAsterCapitalBSC(response.data.filter(account => account.account_name === "BLUE ASTER CAPITAL B.S.C CLOSED"));
    } catch (error) {
      console.error("Error fetching accounts:", error);
    }
  };

  useEffect(() => {
    axios
      .get(ExchangeApiUrl)
      .then((response) => {
        setExchangeRates(response.data.rates);
      })
      .catch((error) => console.error("Error fetching exchange rates:", error));
  }, []);

  // Convert amount to USD
  const convertToUSD = (amount, currency) => {
    if (currency === "USD") return amount;
    const rate = exchangeRates[currency] || 1;
    return amount / rate;
  };

  // Calculate total balance in USD
  const totalBalanceUSD = bankAccounts.reduce(
    (acc, account) => acc + convertToUSD(account.available_balance, account.currency),
    0
  );

  const pieData = {
    labels: bankAccounts.map((account) => {
      const amountInUSD = convertToUSD(account.available_balance, account.currency);
      const percentage = ((amountInUSD / totalBalanceUSD) * 100).toFixed(2);
      return `${account.bank_name} (${account.currency}) - ${percentage}%`;
    }),
    datasets: [
      {
        data: bankAccounts.map((account) => convertToUSD(account.available_balance, account.currency)),
        backgroundColor: ["#0088FE", "#FFBB28", "#00C49F", "#FF8042", "#A28EFF"],
        hoverBackgroundColor: ["#0050A0", "#FF8800", "#008060", "#D96B00", "#7B5AA0"],
      },
    ],
  };

  // Initialize DataTable
  useEffect(() => {
    if (bankAccounts.length > 0) {
      const table = $("#dataTable").DataTable({
        destroy: true,
        pageLength: 10,
      });
      return () => {
        table.destroy();
      };
    }
  }, [bankAccounts]);

  // Update balance API call
  const updateBalance = async () => {
    if (!selectedAccount || !updatedBalance || !updateDate) {
      alert("Please fill in all fields.");
      return;
    }

    try {
      await axios.post(`${BaseUrl}/update-balance`, {
        account_id: selectedAccount.id,
        updated_balance: updatedBalance,
        update_date: updateDate,
      });

      alert("Balance updated successfully!");
      fetchAccounts(); // Refresh data
      fetchUpdateHistory(selectedAccount);
      setShowUpdateModal(false)
    } catch (error) {
      console.error("Error updating balance:", error);
    }
  };

  // Fetch update history
  const fetchUpdateHistory = async (accountId) => {
    try {
      const response = await axios.get(`${BaseUrl}/balance-history/${accountId}`);
      setUpdateHistory(response.data);
    } catch (error) {
      console.error("Error fetching history:", error);
    }
  };

  const formatISTDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", { day: "2-digit", month: "2-digit", year: "numeric" });
  };

  return (
    <>
      <Row>
        <Col xl={6} lg={6}>
          <Card className="widget-flat shadow-md" style={{ height: "200px" }}>
            <Card.Body className="p-0 d-flex flex-column justify-content-center align-items-center">
              <div className="p-3 pb-0 text-center">
                <div className="mb-2">
                  <i
                    className="mdi mdi-currency-usd text-danger widget-icon"
                    style={{ fontSize: "48px" }}
                  ></i>
                </div>
                <h4 className="text font-weight-normal mt-0">Total Bank Balance</h4>
                <h6 className="mt-2">$ {totalBalanceUSD.toLocaleString()}</h6>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col xl={6} lg={6}>
          <div className="card p-3 w-100 d-flex flex-column align-items-center">
            <div className="card-header text-center">
              <h5>Overview of Bank</h5>
            </div>
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ width: "100%", maxWidth: "350px", height: "350px" }}
            >
              <Pie data={pieData} />
            </div>
          </div>
        </Col>
      </Row>

           <div className="card basic-data-table">
         <div className="card-body">
           <div className="table-responsive">
             <h4>Blue Aster Capital Fund P.C.C</h4>
             <table className="table bordered-table mb-0" id="dataTable1" data-page-length={10}>
               <thead>
                 <tr className="bg-gray-200">
                   <th className="border p-2 ">Bank Details</th>
                   <th className="border p-2">Currency</th>
                   <th className="border p-2">Balance</th>
                   <th className="border p-2">Actions</th>
                 </tr>
               </thead>
               <tbody>
                 {blueAsterCapitalFund.map((item, index) => (
                   <tr key={index} className="text-left">
                <td className="border p-2">
                  {`Bank Name: ${item.bank_name || "N/A"}`} <br />
                  {`Account Name: ${item.account_name || "N/A"}`} <br />
                  {`Account Number: ${item.account_number || "N/A"}`} <br />
                  {`IBAN: ${item.iban || "N/A"}`} <br />
                  {`SWIFT: ${item.swift_code || "N/A"}`}
                 </td>
                    <td className="border p-2">{item.currency}</td>
                     <td className="border p-2">{item.available_balance}</td>
                     <td className="border p-2">
                      <Button
                        size="sm"
                        variant="primary"
                        onClick={() => {
                          setSelectedAccount(item);
                          setShowUpdateModal(true);
                        }}
                      >
                        Update Balance
                      </Button>
                      &nbsp;
                      <Button
                        size="sm"
                        variant="secondary"
                        onClick={() => {
                          fetchUpdateHistory(item.id)
                          setShowHistoryModal(true);
                        }}
                      >
                        View History
                      </Button>
                    </td>
                   </tr>
                 ))}
               </tbody>
             </table>
           </div>
         </div>
       </div>

       <div className="card basic-data-table">
         <div className="card-body">
           <div className="table-responsive">
             <h4>BLUE ASTER CAPITAL B.S.C CLOSED</h4>
             <table className="table bordered-table mb-0" id="dataTable2" data-page-length={10}>
               <thead>
                 <tr className="bg-gray-200">
                   <th className="border p-2">Bank Details</th>
                   <th className="border p-2">Currency</th>
                   <th className="border p-2">Balance</th>
                   <th className="border p-2">Actions</th>
                 </tr>
               </thead>
               <tbody>
                 {blueAsterCapitalBSC.map((item, index) => (
                   <tr key={index} className="text-left">
                    <td className="border p-2">
                    {`Bank Name: ${item.bank_name || "N/A"}`} <br />
                    {`Account Name: ${item.account_name || "N/A"}`} <br />
                    {`Account Number: ${item.account_number || "N/A"}`} <br />
                    {`IBAN: ${item.iban || "N/A"}`} <br />
                    {`SWIFT: ${item.swift_code || "N/A"}`}
                  </td>
                     <td className="border p-2">{item.currency}</td>
                     <td className="border p-2">{item.available_balance}</td>
                     <td className="border p-2">
                      <Button
                        size="sm"
                        variant="primary"
                        onClick={() => {
                          setSelectedAccount(item);
                          setShowUpdateModal(true);
                        }}
                      >
                        Update Balance
                      </Button>
                      &nbsp;
                      <Button
                        size="sm"
                        variant="secondary"
                        onClick={() => {
                          fetchUpdateHistory(item.id)
                          setShowHistoryModal(true);
                        }}
                      >
                        View History
                      </Button>
                    </td>
                   </tr>
                 ))}
               </tbody>
             </table>
          </div>
        </div>
      </div>

       {/* Update Balance Modal */}
       <Modal show={showUpdateModal} onHide={() => setShowUpdateModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Update Balance</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>New Balance</Form.Label>
              <Form.Control
                type="number"
                value={updatedBalance}
                onChange={(e) => setUpdatedBalance(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mt-2">
              <Form.Label>Date</Form.Label>
              <Form.Control
                type="date"
                value={updateDate}
                onChange={(e) => setUpdateDate(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowUpdateModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={updateBalance}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* View History Modal */}
      <Modal show={showHistoryModal} onHide={() => setShowHistoryModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Balance History</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {updateHistory.length > 0 ? (
            <table className="table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Updated Balance</th>
                </tr>
              </thead>
              <tbody>
                {updateHistory.map((record, index) => (
                  <tr key={index}>
                    <td>{formatISTDate(record.update_date)}</td>
                    <td>{record.updated_balance}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No history available.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowHistoryModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      
    </>
  );
};

export default Bank;
